module.exports = __webpack_public_path__ + "static/img/22.b8262186.gif";